export const msalConfig = {
  auth: {
    clientId: '9c29cf99-60d5-4d33-832c-9b6da4e01a30',
    authority: 'https://login.microsoftonline.com/6f4432dc-20d2-441d-b1db-ac3380ba633d',
    redirectUri: process.env.VUE_APP_MICROSOFT_AUTH_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read']
};

export const tokenRequest = {
  scopes: ['User.Read', 'Mail.Read']
};
